import { render, staticRenderFns } from "./ManageConsumer.vue?vue&type=template&id=34688ac2&"
import script from "./ManageConsumer.vue?vue&type=script&lang=js&"
export * from "./ManageConsumer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports